import { updateFacebookStats } from "@/api/home";

type FbqFunction = (...args: any[]) => void

export const initFacebookPixel = (): void => {
    if (localStorage.getItem('fbPixelId')) {
        if (typeof window.fbq === 'function') return

            ; (function (f: any, b: Document, e: string, v: string, n?: any, t?: any, s?: any) {
                if (typeof f.fbq === 'function') return

                n = f.fbq = function (...args: any[]) {
                    n.callMethod ? n.callMethod(...args) : n.queue.push(args)
                }

                n.loaded = true
                n.version = '2.0'
                n.queue = []

                t = b.createElement(e)
                t.async = true
                t.src = v
                s = b.getElementsByTagName(e)[0]
                s.parentNode?.insertBefore(t, s)
            })(
                window,
                document,
                'script',
                'https://connect.facebook.net/en_US/fbevents.js'
            )

            ; (window.fbq as FbqFunction)('init', localStorage.getItem('fbPixelId'))
            ; (window.fbq as FbqFunction)('track', 'PageView')
    }
}

export const trackFacebookPageView = (): boolean => {
    if (typeof window.fbq !== 'function') return false

        ; (window.fbq as FbqFunction)('track', 'PageView')
    return true
}

export const trackingEvent = (eventName: string) => {
    const channel_code = localStorage.getItem('fbChannelCode')
    if(eventName == 'PageView'){
              const storedDate = localStorage.getItem('pageViewDate');
                const today = new Date().toDateString();
                if (storedDate !== today ) {
                    localStorage.setItem('pageViewDate', today);
                } else {
                    return; 
                }
           }

    const data = {
        eventType: eventName,
        channelCode: channel_code
    }

    updateFacebookStats(data)
        .then(res => {
            console.log('trackingEvent res:', res)
        })
        .catch(err => {
           console.log("ERR",err)
        })
}
